const VIEWPORT_PAD = 16;
const GAP = 12;
const DEFAULT_BUBBLE_WIDTH = 288;
const DEFAULT_BUBBLE_HEIGHT = 200;

function uniquePlacements(preferred) {
  const order = [preferred, 'bottom', 'top', 'right', 'left'];
  return order.filter((p, i) => order.indexOf(p) === i);
}

function coordsForPlacement(placement, rect, width, height, gap = GAP) {
  const cx = rect.left + rect.width / 2;
  const cy = rect.top + rect.height / 2;

  switch (placement) {
    case 'top':
      return { top: rect.top - gap - height, left: cx - width / 2 };
    case 'right':
      return { top: cy - height / 2, left: rect.right + gap };
    case 'left':
      return { top: cy - height / 2, left: rect.left - gap - width };
    case 'bottom':
    default:
      return { top: rect.bottom + gap, left: cx - width / 2 };
  }
}

function overflowScore(top, left, width, height, vw, vh, pad) {
  return (
    Math.max(0, pad - top) +
    Math.max(0, pad - left) +
    Math.max(0, top + height - (vh - pad)) +
    Math.max(0, left + width - (vw - pad))
  );
}

function clampBox(top, left, width, height, vw, vh, pad = VIEWPORT_PAD) {
  return {
    top: Math.max(pad, Math.min(top, vh - height - pad)),
    left: Math.max(pad, Math.min(left, vw - width - pad))
  };
}

/**
 * Pick placement and fixed viewport coordinates for a tutorial bubble.
 * @param {DOMRect} anchorRect
 * @param {'top'|'bottom'|'left'|'right'} preferredPlacement
 * @param {number} bubbleWidth
 * @param {number} bubbleHeight
 */
export function computeGuideBubbleLayout(
  anchorRect,
  preferredPlacement = 'bottom',
  bubbleWidth = DEFAULT_BUBBLE_WIDTH,
  bubbleHeight = DEFAULT_BUBBLE_HEIGHT
) {
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const width = Math.min(bubbleWidth, vw - VIEWPORT_PAD * 2);
  const height = bubbleHeight;

  let best = null;

  for (const placement of uniquePlacements(preferredPlacement)) {
    const raw = coordsForPlacement(placement, anchorRect, width, height);
    const clamped = clampBox(raw.top, raw.left, width, height, vw, vh);
    const score = overflowScore(clamped.top, clamped.left, width, height, vw, vh, VIEWPORT_PAD);
    const entry = { placement, top: clamped.top, left: clamped.left, score };

    if (!best || score < best.score || (score === best.score && placement === preferredPlacement)) {
      best = entry;
    }
    if (score <= 0) break;
  }

  const anchorCenterX = anchorRect.left + anchorRect.width / 2;
  const arrowOffset = Math.round(
    Math.max(24, Math.min(width - 24, anchorCenterX - best.left))
  );

  return {
    placement: best.placement,
    top: best.top,
    left: best.left,
    arrowOffset,
    width
  };
}

export { DEFAULT_BUBBLE_HEIGHT, DEFAULT_BUBBLE_WIDTH, VIEWPORT_PAD };
